export const blockIconsCommunicationHourglassTop = (
	<span className='material-symbols-outlined'>hourglass_top</span>
);
